import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import CustomModal from "../../../../../components/Modal/CustomModal";
import { CustomTextField } from "../../../../../components/CustomTextField";

/**
 *
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 *
 * CancelModal component renders a confirmation modal with a text field
 * to provide a reason for cancellation. The modal validates that the comment
 * is filled before calling the `onConfirm` function.
 *
 * @param {Object} props - Component props.
 * @param {Function} props.onConfirm - Function to execute when the user confirms the cancellation.
 *                                     Receives the comment as second argument.
 * @param {Function} props.onHide - Function to close the modal.
 * @param {string} props.title_modal - Translation key for the modal title.
 * @param {string} props.description - Description text shown in the modal body.
 * @param {string} props.requiredComment - indicates that the comment is required if it is set to true.
 *
 * @returns {JSX.Element} - Rendered CancelModal component.
 */
const CancelModal = (props) => {
    const { onConfirm, onHide, title_modal, description, requiredComment=true, subDescription} = props;
    const { t } = useTranslation();
    const [emptyFields, setEmptyFields] = useState(false);
    const [comment, setComment] = useState("");

    /**
     * Handles the confirm button click.
     * Validates that the comment field is not empty before
     * calling the `onConfirm` callback.
     *
     * @param {Event} e - The click event.
     */
    const onClickFn = (e) => {
        if (!comment && requiredComment) {
            setEmptyFields(true);
            return;
        }
        onConfirm(e, comment);
        setComment("");
        onHide();
    };

    return (
        <CustomModal
            title={t(title_modal)}
            size='md'
            buttonConfirm='confirm'
            {...props}
            onHide={onHide}
            onConfirm={onClickFn}
        >
            <div className="col-12 text-center">
                <p className='fs-14px'>{description}</p>
                <p className='text-uppercase fs-14px ibl-font-w-700 mt-3'>
                    {subDescription}
                </p>
            </div>
            <div className="col-12 mt-4">
                <CustomTextField
                    length={512}
                    id='txt_cm_comment'
                    name='comment'
                    value={comment}
                    trans='comment'
                    emptyFields={emptyFields}
                    required={requiredComment}
                    onChange={(e) => setComment(e.target.value)}
                    multiline={true}
                    row={4}
                />
            </div>
        </CustomModal>
    );
};

export default CancelModal;
